import classNames from "classnames"
import React from "react"

import { Checkbox } from "@components/elements/V2/Inputs/Checkbox"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { getTransparentBorderColorClass } from "@utils/V2/color"

type Props = {
  text: string
  description?: string
  active?: boolean
  onClick?: () => void
}

const AnswerSelect = ({
  text,
  description,
  active = false,
  onClick,
}: Props) => {
  return (
    <button
      onClick={onClick}
      className={classNames(
        "rounded-xs group flex w-full border-[1px] bg-white p-20 shadow-[0_10px_20px_0_rgba(0,0,0,0.05)] transition-colors duration-200 hover:border-[2px] hover:border-blue hover:p-[19px]",
        !active && getTransparentBorderColorClass(Color.Charcoal),
        active && "border-[2px] border-blue p-[19px]"
      )}
    >
      <Checkbox isChecked={active} id={text} className="pr-10" />
      <div className="flex flex-col items-start text-left">
        <Typography
          text={text}
          font="grotesk"
          weight="medium"
          size="body-lg"
          color={Color.Black}
        />

        {description && (
          <Typography
            text={description}
            font="grotesk"
            weight="book"
            size="body-sm"
            color={Color.Charcoal}
            className="mt-[2px] opacity-50"
          />
        )}
      </div>
    </button>
  )
}

export default AnswerSelect
